const OPTION_NONE = { id: '', value: 'None' };
const OPTION_JOINT = { id: '-1', value: 'Joint' };
const OPTION_OTHER = { id: '-2', value: 'Other' };

const getClientNamePretty = client => `${client.attr('firstName')} ${client.attr('lastName')}`;
const getClientPicklistValue = (options, clientId) => {
  const found = options.find(option => option.id.toString() === clientId);
  if (found) {
    return found.value;
  }
  return OPTION_NONE.value;
};
const getClientPicklistOptions = (householdResource) => {
  const options = [];

  if (householdResource) {
    const clientNameOptions = householdResource.attr('clients').resources().list().map((client) => {
      return {
        id: client.id(),
        value: getClientNamePretty(client),
      };
    });
    options.push(...clientNameOptions);
  }

  if (options.length > 1) {
    options.push(OPTION_JOINT);
  }

  return [...options, OPTION_OTHER, OPTION_NONE];
};
const shouldMakeNotesFieldReadOnly = clientId => clientId !== OPTION_OTHER.id;
export {
  getClientPicklistValue, getClientPicklistOptions, shouldMakeNotesFieldReadOnly,
};
